import React from 'react';
import { Card } from './ui/card';
import './TeamSection.css';

const TeamSection = ({ team, settings }) => {
  return (
    <section id="equipo" className="team-section">
      <div className="team-container">
        <div className="section-header">
          <h2 className="section-title">Nuestro Equipo</h2>
          <p className="section-description">
            Profesionales altamente capacitados y comprometidos con el desarrollo integral de cada niño.
            <br />
            Nuestro equipo combina experiencia clínica con calidez humana.
          </p>
        </div>

        <div className="team-grid">
          {team.map((member, index) =>
          <Card key={member.id || index} className="team-card">
              <div className="team-image-wrapper">
                <img
                src={member.image}
                alt={member.name}
                className="team-image" />

              </div>
              <div className="team-content">
                <h3 className="team-name">{member.name}</h3>
                <p className="team-role">{member.role}</p>
                <p className="team-specialty">{member.specialty}</p>
              </div>
            </Card>
          )}
        </div>

        <div className="stats-section">
          <div className="stats-header">
            <h3 className="stats-title">Certificaciones y Formación Continua</h3>
          </div>
          <div className="stats-grid">
            <div className="stat-item">
              <div className="stat-value">{settings.stat_1_value || '100%'}</div>
              <div className="stat-label">{settings.stat_1_label || 'Profesionales Certificados'}</div>
            </div>
            <div className="stat-item">
              <div className="stat-value">{settings.stat_2_value || '+5'}</div>
              <div className="stat-label">{settings.stat_2_label || 'Años de Experiencia'}</div>
            </div>
            <div className="stat-item">
              <div className="stat-value">{settings.stat_3_value || '+70'}</div>
              <div className="stat-label">{settings.stat_3_label || 'Familias Atendidas'}</div>
            </div>
          </div>
        </div>
      </div>
    </section>);

};

export default TeamSection;
